import { get } from 'lodash'

import { ProtocolsType } from 'types/Protocols.types'

import { types } from './Protocols.actions'

type Certifications = {
  certifications: any[]
  selectedCertifications: any | null
  loading: boolean
  options?: any[]
  protocols: {
    items: ProtocolsType[]
    pagination: {
      totalItems: number
      limit: number
      page: number
    }
  }
  editProtocols?: ProtocolsType
  protocolsUpdated?: ProtocolsType
  protocolsCreated?: ProtocolsType
}

const INITIAL_STATE = {
  certifications: [],
  protocols: {
    items: [],
    pagination: null
  },
  selectedCertifications: null,
  loading: false,
  options: [],
  editProtocols: {} as ProtocolsType,
  protocolsUpdated: {} as ProtocolsType,
  protocolsCreated: {} as ProtocolsType
}

function setState(state: Certifications) {
  return function _handle(payload: Record<string, any>) {
    return { ...state, ...payload }
  }
}

export default function _reducer(state = INITIAL_STATE, { type, payload }) {
  const _handlers = {
    [types.SET_LOADING]: setState(state),
    [types.SET_PROTOCOLS]: setState(state),
    [types.SET_SELECTED_PROTOCOLS]: setState(state),
    [types.SET_PROTOCOLS_OPTIONS]: setState(state),
    [types.CREATE_PROTOCOLS]: setState(state),
    [types.CLEAN_PROTOCOLS]: setState(state),
    [types.SET_CREATED_PROTOCOLS]: setState(state),
    [types.SET_UPDATED_PROTOCOLS]: setState(state),
    [types.EDIT_PROTOCOLS]: setState(state),
    _default: () => state
  }

  return get(_handlers, type, _handlers._default)(payload)
}
